exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.wh_indicator .wh_indicator_item {\n  width: 0.08rem;\n  height: 0.08rem;\n  background: #ffffff;\n  opacity: 0.5;\n  border-radius: 50%;\n}\n.wh_indicator .wh_show_bgcolor {\n  width: 0.28rem;\n  height: 0.08rem;\n  background: #ffffff;\n  opacity: 0.9;\n  border-radius: 0.08rem;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-47323bf2","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1&bustCache!./src/components/index.vue
// module id = r/TJ
// module chunks = 1